import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容分类',
    links: [
      { name: '火影同人漫画', path: '/category/manhua' },
      { name: '火影同人小说', path: '/category/xiaoshuo' },
      { name: '火影同人画集', path: '/category/huaji' },
      { name: '火影CP同人', path: '/category/cp' },
      { name: '同人活动资讯', path: '/category/huodong' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', path: '/about' },
      { name: '投稿指南', path: '/about#submit' },
      { name: '联系我们', path: '/about#contact' },
    ],
  },
  {
    title: '友情链接',
    links: [
      { name: 'CPP无差别同人站', path: 'https://www.allcpp.com/', external: true },
      { name: '天窗联盟', path: 'https://doujin.bgm.tv/', external: true },
      { name: 'Bilibili同人区', path: 'https://www.bilibili.com/v/douga/tongren/', external: true },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl">火影同人本子</span>
            </div>
            <p className="text-sm text-secondary-200 leading-relaxed">
              汇聚优质火影同人创作资源，涵盖漫画、小说、画集等多种形式。连接同人作者与读者，让每一份热爱都被看见。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-base mb-4 text-background-50">{group.title}</h4>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) =>
                  link.external ? (
                    <li key={link.name}>
                      <a
                        href={link.path}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="text-sm text-secondary-200 hover:text-primary-400 transition-colors whitespace-nowrap"
                      >
                        {link.name}
                      </a>
                    </li>
                  ) : (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-sm text-secondary-200 hover:text-primary-400 transition-colors whitespace-nowrap"
                      >
                        {link.name}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-300">
            &copy; 2026 火影同人本子 版权所有。本站为同人爱好者社区，与《火影忍者》版权方无官方关联。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-secondary-300 hover:text-primary-400 transition-colors">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-secondary-300 hover:text-primary-400 transition-colors">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-secondary-300 hover:text-primary-400 transition-colors">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}